const routes = [
  {
    path: "/",
    name: "home",
    meta: { title: "首页" },
    redirect: "/dikong"
  },
    {
    path: "/aijiaoxue",
    name: "Home",
    component: () => import("@/views/index.vue")
  },
  {
    path: "/news",
    name: "news",
    component: () => import("@/views/news/index.vue"),
  },
  {
    path: "/newsDetail",
    name: "newsDetail",
    component: () => import("@/views/newsDetail/index.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/login.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/login/register.vue"),
  },
  {
    path: "/teachersImprove",
    name: "teachersImprove",
    component: () => import("@/views/teachersImprove/index.vue"),
  },
  {
    path: "/resource",
    name: "resource",
    component: () => import("@/views/resource/index.vue"),
  },
  {
    path: "/courseDetail",
    name: "courseDetail",
    component: () => import("@/views/courseDetail/index.vue"),
  },
  {
    path: "/contactUs",
    name: "contactUs",
    component: () => import("@/views/contactUs/index.vue"),
  },
  {
    path: "/buyRemind",
    name: "buyRemind",
    component: () => import("@/views/buyRemind/index.vue"),
  },
  {
    path: "/bankInfo",
    name: "bankInfo",
    component: () => import("@/views/bankInfo/index.vue"),
  },
  {
    path: "/courseCenter",
    name: "courseCenter",
    component: () => import("@/views/courseCenter/index.vue"),
  },
  {
    path: "/kcDetail",
    name: "kcDetail",
    component: () => import("@/views/courseCenter/detail.vue"),
  },
  {
    path: "/coursePlay",
    name: "coursePlay",
    component: () => import("@/views/courseCenter/coursePlay.vue"),
  },
  {
    path: "/myHomework",
    name: "myHomework",
    component: () => import("@/views/myHomework/index.vue"),
  },
  {
    path: "/teacher",
    name: "teacher",
    component: () => import("@/views/teacher/index.vue"),
  },
  {
    path: "/teachPlay",
    name: "teachPlay",
    component: () => import("@/views/teacher/teachPlay.vue"),
  },

  {
    path: "/dikong",
    component: () => import("@/views/dikong/Home"),
    name: "home",
    meta: { title: "首页" },
  },
  {
    path: "/dikong/login",
    component: () => import("@/views/dikong/login"),
    name: "login",
    meta: { title: "登录", needLogin: false },
  },
  {
    path: "/dikong/agreement",
    component: () => import("@/views/dikong/agreement"),
    name: "agreement",
    meta: { title: "协议", needLogin: false },
  },
  {
    path: "/dikong/news",
    component: () => import("@/views/dikong/news"),
    name: "news",
    meta: { title: "新闻" },
  },
  {
    path: "/dikong/newsDetail",
    component: () => import("@/views/dikong/newsDetail"),
    name: "newsDetail",
    meta: { title: "新闻详情" },
  },
  {
    path: "/dikong/information",
    component: () => import("@/views/dikong/information"),
    name: "information",
    meta: { title: "资料" },
  },
  {
    path: "/dikong/skill",
    component: () => import("@/views/dikong/skill"),
    name: "skill",
    meta: { title: "职业技能" },
  },
  {
    path: "/dikong/exam",
    component: () => import("@/views/dikong/exam"),
    name: "exam",
    meta: { title: "考试指南" },
  },
  {
    path: "/dikong/wurenji",
    component: () => import("@/views/dikong/wurenji"),
    name: "wurenji",
    meta: { title: "无人机" },
  },
  {
    path: "/dikong/order",
    component: () => import("@/views/dikong/order"),
    name: "order",
    meta: { title: "订单" },
  },
  {
    path: "/dikong/purchase",
    component: () => import("@/views/dikong/purchase"),
    name: "purchase",
    meta: { title: "购买" },
  },
  {
    path: "/dikong/start",
    component: () => import("@/views/dikong/start"),
    name: "start",
    meta: { title: "开始学习" },
  },
  {
    path: "/dikong/examination",
    component: () => import("@/views/dikong/examination"),
    name: "examination",
    meta: { title: "考试" },
  },
  {
    path: "/dikong/low",
    component: () => import("@/views/dikong/low"),
    name: "low",
    meta: { title: "低空应用" },
  },
  {
    path: "/dikong/questionBank",
    component: () => import("@/views/dikong/questionBank"),
    name: "questionBank",
    meta: { title: "题库" },
  },
  {
    path: "/dikong/vocationalSkills",
    component: () => import("@/views/dikong/VocationalSkills"),
    name: "vocationalSkills",
    meta: { title: "职业技能" },
  },
  {
    path: "/dikong/classDetail",
    component: () => import("@/views/dikong/classDetail"),
    name: "classDetail",
    meta: { title: "课程详情" },
  },
  {
    path: "/dikong/zuoti",
    component: () => import("@/views/dikong/zuoti"),
    name: "zuoti",
    meta: { title: "做题" },
  },
  {
    path: "/dikong/jiaojuan",
    component: () => import("@/views/dikong/jiaojuan"),
    name: "jiaojuan",
    meta: { title: "交卷" },
  },
  {
    path: "/dikong/zhifu",
    component: () => import("@/views/dikong/zhifu"),
    name: "zhifu",
    meta: { title: "支付" },
  },
  {
    path: "/dikong/tuikuan",
    component: () => import("@/views/dikong/tuikuan"),
    name: "tuikuan",
    meta: { title: "退款" },
  },
  {
    path: "/dikong/lianxifangshi",
    component: () => import("@/views/dikong/lianxifangshi"),
    name: "lianxifangshi",
    meta: { title: "联系方式" },
  },
];

export default routes;
